import type { IconProps } from '../types/icons';

export default function InformationOutlineIcon({
  width = 21,
  height = 20,
  fill = '#9FA3A9',
  className = '',
  ...rest
}: IconProps & { id?: string; tooltip?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      className={className}
      id={rest.id}
      data-for={rest.id}
      data-tip={rest.tooltip}
    >
      <path
        transform={`scale(${width / 21},${height / 20})`}
        d="M9.83301 7.5H11.4997V5.83334H9.83301M10.6663 16.6667C6.99134 16.6667 3.99967 13.675 3.99967 10C3.99967 6.32501 6.99134 3.33334 10.6663 3.33334C14.3413 3.33334 17.333 6.32501 17.333 10C17.333 13.675 14.3413 16.6667 10.6663 16.6667ZM10.6663 1.66667C9.57199 1.66667 8.48836 1.88222 7.47731 2.30101C6.46627 2.7198 5.54761 3.33363 4.77378 4.10745C3.21098 5.67025 2.33301 7.78987 2.33301 10C2.33301 12.2101 3.21098 14.3298 4.77378 15.8926C5.54761 16.6664 6.46627 17.2802 7.47731 17.699C8.48836 18.1178 9.57199 18.3333 10.6663 18.3333C12.8765 18.3333 14.9961 17.4554 16.5589 15.8926C18.1217 14.3298 18.9997 12.2101 18.9997 10C18.9997 8.90566 18.7841 7.82202 18.3653 6.81098C17.9465 5.79993 17.3327 4.88127 16.5589 4.10745C15.7851 3.33363 14.8664 2.7198 13.8554 2.30101C12.8443 1.88222 11.7607 1.66667 10.6663 1.66667ZM9.83301 14.1667H11.4997V9.16667H9.83301V14.1667Z"
        fill={fill}
      />
    </svg>
  );
}
